import { QueryParamsEntities4 } from "@/domain/entities/MainApp";

export class POSLeaderboardListRequest {
  period = "";
  scope = "";
  limit = 20;
  cursor: null | number = null;

  constructor(fields?: Partial<POSLeaderboardListRequest>) {
    Object.assign(this, fields);
  }

  toQueryString() {
    return new QueryParamsEntities4(this).queryString
  }
}
